import { aludraApi } from 'api/axios'
import { mdl07Urls } from './mdl07.urls'

export const summaryTaskType = async => {
  return aludraApi.get(mdl07Urls.tasksURL)
}

export const summaryTask = async payload => {
  return aludraApi.post(mdl07Urls.fetchTasksURL, payload)
}
